// extracted by mini-css-extract-plugin
module.exports = {"dropzone":"dropzone_dropzone__1iap7","dropFont":"dropzone_dropFont__1Lh5S","qrcode":"dropzone_qrcode__2ezQ0","closeIcon":"dropzone_closeIcon__1mga2"};